import React, { useContext, useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Link } from "react-router-dom";
import { context } from "../context/context";
import TextEditorUploader from "./TextEditorUploader";
// Remove the unnecessary part from the import statement

const TextEditor = () => {
    const editorRef = useRef();
    // const location = useLocation();
    const { textEditorHTML, setTextEditorHTML, linkAddress } =
        useContext(context);

    // console.log(linkAddress);
    //   const { state: { urls } = {} } = location;
    // متغیر برای بررسی آیا محتوای localStorage پاک شده است یا خیر
    // const [localStorageCleared, setLocalStorageCleared] = useState(false);
    //   const [mediaUrls, setMediaUrls] = useState(
    //     Array.isArray(urls) ? urls : [urls]
    //   );

    // استفاده از متغیر موقت به عنوان مقدار اولیه برای محتوا
    const [content, setContent] = useState(
        textEditorHTML
        // localStorageCleared ? "" : localStorage.getItem("editorContent")
    );
    //   const sendContentToBackend = () => {
    //     if (editorRef.current) {
    //       const content = editorRef.current.getContent();

    //       // Assuming you have a backend API endpoint for saving content
    //       const apiUrl = "YOUR_BACKEND_API_URL";

    //       // Send the content to the backend
    //       fetch(apiUrl, {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({ content }),
    //       })
    //         .then((response) => response.json())
    //         .then((data) => {
    //           // Handle the response from the backend if needed
    //           console.log("Content sent to the backend:", data);

    //           // Clear the editor content
    //           setContent("");

    //           // Refresh the page
    //           window.location.reload();
    //         })
    //         .catch((error) => {
    //           console.error("Error sending content to the backend:", error);
    //         });
    //     }
    //   };

    // const changeEditorContent = (newContent) => {
    //   // Update the content state
    //   setContent(newContent);
    //   // Save the content in temporary state

    //   // Save the content in local storage
    //   // localStorage.setItem("editorContent", newContent);
    // };
    //   const AddMedia = () => {
    //     if (editorRef.current) {
    //       const mediaUrlsArray = Array.isArray(mediaUrls) ? mediaUrls : [mediaUrls];
    //       mediaUrlsArray.forEach((mediaUrl) => {
    //         let mediaHtml;
    //         if (
    //           mediaUrl.endsWith(".mp4") ||
    //           mediaUrl.endsWith(".webm") ||
    //           mediaUrl.endsWith(".ogg")
    //         ) {
    //           // Insert video
    //           mediaHtml = `<video width="320" height="240" controls><source src="${mediaUrl}" type="video/mp4">Your browser does not support the video tag.</video>`;
    //         } else if (
    //           mediaUrl.endsWith(".mp3") ||
    //           mediaUrl.endsWith(".wav") ||
    //           mediaUrl.endsWith(".ogg")
    //         ) {
    //           // Insert audio
    //           mediaHtml = `<audio controls><source src="${mediaUrl}" type="audio/mpeg">Your browser does not support the audio element.</audio>`;
    //         } else if (
    //           mediaUrl.endsWith(".jpg") ||
    //           mediaUrl.endsWith(".png") ||
    //           mediaUrl.endsWith(".jpeg")
    //         ) {
    //           // Insert image
    //           mediaHtml = `<img src="${mediaUrl}" alt="Media" />`;
    //         }

    //         editorRef.current.execCommand("mceInsertContent", false, mediaHtml);
    //       });
    //     }
    //   };

    const logEditorContent = () => {
        if (editorRef.current) {
            const content = editorRef.current.getContent();
            // console.log(content);
            setTextEditorHTML(content);
            // localStorage.setItem("editorContent", content);
        }
    };

    const [selectedFont, setSelectedFont] = useState("Arial"); // اضافه کردن وضعیت انتخاب فونت
    const changeFont = (font) => {
        if (editorRef.current) {
            editorRef.current.execCommand("fontName", false, font);
            setSelectedFont(font);
        }
    };
    // console.log(textEditorHTML);
    //   useEffect(() => {
    //     // Log the 'urls' prop when it changes
    //     console.log("Received prop (urls):", urls);
    //     setMediaUrls(urls); // Update imageUrls state if needed
    //   }, [urls]); // 'urls' is added to the dependency array
    // useEffect(() => {
    //   // Clear localStorage when the component mounts (page is refreshed)
    //   if (!localStorageCleared) {
    //     localStorage.removeItem("editorContent");
    //     setLocalStorageCleared(true);
    //   }
    // }, []);
    useEffect(() => {
        if (linkAddress && !content.includes(linkAddress)) {
            setContent(
                content +
                    `<img src=${linkAddress} alt="" width="192" height="192" />`
            );
        }
    }, [linkAddress, content]);
    return (
        <div>
            <nav className="nav">
                <div className="nav-div">
                    {/* <a href="#"> */}
                    <h1 className="ziba">ویرایشگر متن</h1>
                    {/* </a> */}
                    <div className="log">
                        {/* <button className="firstbtn" onClick={logEditorContent}>
              کنسول
            </button> */}
                        {/* <button
                            // className="secbtn"
                            //   onClick={AddMedia}
                        > */}
                            <TextEditorUploader />
                        {/* </button> */}
                        {/* <button
              className="thirdbtn"
              //   onClick={sendContentToBackend}
            >
              ثبت و ارسال نهایی
            </button> */}
                    </div>
                </div>
            </nav>

            <Editor
                onEditorChange={logEditorContent}
                // onChange={logEditorContent}
                apiKey="uu2ynkaqozwvmrxrh377yyzvp7l6ilvqf8zjuab8mitkm445"
                onInit={(evt, editor) => (editorRef.current = editor)}
                initialValue={content}
                init={{
                    selector: "textarea",
                    height: 370,
                    menubar: false,
                    plugins: [
                        "fontselect",
                        "advlist",
                        "autolink",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "preview",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "code",
                        "fullscreen",
                        "insertdatetime",
                        "media",
                        "table",
                        "editimage",
                        "wordcount",
                        "textcolor",
                    ],
                    textcolor_cols: "5",
                    textcolor_rows: "4",
                    textcolor_map: [
                        "000000",
                        "Black",
                        "993300",
                        "Burnt orange",
                        "333300",
                        "Dark olive",
                        "003300",
                        "Dark green",
                        "003366",
                        "Dark azure",
                        "000080",
                        "Navy Blue",
                        "333399",
                        "Indigo",
                        "333333",
                        "Very dark gray",
                        "800000",
                        "Maroon",
                        "FF6600",
                        "Orange",
                        "808000",
                        "Olive",
                        "008000",
                        "Green",
                        "008080",
                        "Teal",
                        "0000FF",
                        "Blue",
                        "666699",
                        "Grayish blue",
                        "808080",
                        "Gray",
                        "FF0000",
                        "Red",
                        "FF9900",
                        "Amber",
                        "99CC00",
                        "Yellow green",
                        "339966",
                        "Sea green",
                        "33CCCC",
                        "Turquoise",
                        "3366FF",
                        "Royal blue",
                        "800080",
                        "Purple",
                        "999999",
                        "Medium gray",
                        "FF00FF",
                        "Magenta",
                        "FFCC00",
                        "Gold",
                        "FFFF00",
                        "Yellow",
                        "00FF00",
                        "Lime",
                        "00FFFF",
                        "Aqua",
                        "00CCFF",
                        "Sky blue",
                        "993366",
                        "Red violet",
                        "FFFFFF",
                        "White",
                        "FF99CC",
                        "Pink",
                        "FFCC99",
                        "Peach",
                        "FFFF99",
                        "Light yellow",
                        "CCFFCC",
                        "Pale green",
                        "CCFFFF",
                        "Pale cyan",
                        "99CCFF",
                        "Light sky blue",
                        "CC99FF",
                        "Plum",
                    ],
                    toolbar:
                        "undo redo | styles | bold italic | fontselect | alignleft aligncenter alignright alignjustif\
                    y | bullist numlist outdent indent | link image | rtl | forecolor backcolor | sizeselect | bold italic | fontselect | fontsize", // اضافه کردن دکمه RTL به نوار ابزار

                    directionality: "rtl", // تغییر به راست به چپ (RTL)    };
                    font_formats:
                        "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                    content_style:
                        "@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');",
                    theme_advanced_fonts:
                        "Andale Mono=andale mono,times;" +
                        "Arial=arial,helvetica,sans-serif;" +
                        "Arial Black=arial black,avant garde;" +
                        "Book Antiqua=book antiqua,palatino;" +
                        "Comic Sans MS=comic sans ms,sans-serif;" +
                        "Courier New=courier new,courier;" +
                        "Georgia=georgia,palatino;" +
                        "Helvetica=helvetica;" +
                        "Impact=impact,chicago;" +
                        "Symbol=symbol;" +
                        "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                        "Terminal=terminal,monaco;" +
                        "Times New Roman=times new roman,times;" +
                        "Trebuchet MS=trebuchet ms,geneva;" +
                        "Verdana=verdana,geneva;" +
                        "Webdings=webdings;" +
                        "Wingdings=wingdings,zapf dingbats",
                }}
                // onLoadContent={() => changeEditorContent(AddMedia)}
            />
        </div>
    );
};

export default TextEditor;
